// Helpers for records brought in by the historical data import (appointments/payments,
// DayBooks). Those rows carry an internal marker in their Notes, e.g. "[IMPORTED]" or
// "[IMPORTED:DayBooks]". We never want that raw marker shown to staff — surface a clean
// "Imported" chip instead and strip the marker out of any free-text notes.

const IMPORT_RE = /\[IMPORTED[^\]]*\]/gi;

/** True when the text contains an import marker. */
export const isImported = (text) => !!text && /\[IMPORTED/i.test(String(text));

/** Free-text notes with any import marker removed (empty string if nothing meaningful left). */
export const cleanNotes = (text) => {
  if (!text) return '';
  return String(text).replace(IMPORT_RE, '').replace(/\s{2,}/g, ' ').trim();
};
